var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8213 0.821625L25.0466 6.59636L23.5817 5.13152C22.6125 4.16229 21.3295 3.67644 20.0466 3.67644C18.7636 3.67644 17.4806 4.16229 16.5114 5.13152L12.833 8.80991L11.5114 7.48829L9.15462 9.84506L7.48796 11.5117L8.80957 12.8333L5.13119 16.5117C3.19273 18.4502 3.19273 21.6436 5.13119 23.582L6.59603 25.0469L0.821289 30.8216L3.17806 33.1784L8.9528 27.4037L10.4176 28.8685C12.3561 30.807 15.5495 30.807 17.488 28.8685L21.1663 25.1901L22.488 26.5117L24.1546 24.8451L26.5114 22.4883L25.1898 21.1667L28.8682 17.4883C30.8066 15.5498 30.8066 12.3564 28.8682 10.418L27.4033 8.95314L33.1781 3.1784L30.8213 0.821625ZM20.0466 6.99024C20.4695 6.99024 20.8925 7.15585 21.2249 7.48829L26.5114 12.7748C27.1763 13.4396 27.1763 14.4666 26.5114 15.1315L22.833 18.8099L15.1898 11.1667L18.8682 7.48829C19.2006 7.15585 19.6236 6.99024 20.0466 6.99024ZM11.1663 15.1901L18.8096 22.8333L15.1312 26.5117C14.4663 27.1766 13.4393 27.1766 12.7744 26.5117L7.48796 21.2253C6.82308 20.5604 6.82308 19.5334 7.48796 18.8685L11.1663 15.1901Z",
    fill: "#1F4C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.f1fd4fa0a4c287ee6396e6eeb2a1584c.svg";
export { ForwardRef as ReactComponent };